<template>
  <div id="professionals-single" @keyup="changePhoto">
    <div v-if="isLoading">
      <preloader :title="$t('preloader.loadingPro')"></preloader>
    </div>
    <div v-else-if="!_.isEmpty(professional)">

      <div id="sticky-header">
        <b-container class="text-left">
          <page-avatar class="d-inline-block"
                       size="50px"
                       :userImage="professional.image"
                       :userName="professional.first_name + ' ' + professional.last_name"></page-avatar>
          <div class="user-name font-weight-bold ml-3 d-inline-block" :class="{ verified: professional.membership > 1 }">
            {{ professional.first_name }} {{ professional.last_name }}
            <div v-if="professional.membership === 2"
                 v-b-tooltip.hover
                 :title="$t('professional.verified')"
                 class="verified-badge">
                <span class="material-icons">
                  verified
                </span>
            </div>
            <div v-else-if="professional.membership === 3"
                 v-b-tooltip.hover
                 :title="$t('professional.premium')"
                 class="premium-badge">
              <img width="20" src="https://finefit.s3.eu-north-1.amazonaws.com/images/premium_crown.svg" />
            </div>
            <div v-else class="free-member">({{ $t('professional.freeMember') }})</div>
          </div>
          <div class="specialities d-none d-md-inline-block" v-if="1 === 2 && !_.isEmpty(professional.specialities)">
            (<span class="font-italic" v-for="speciality in professional.specialities">
              {{ $t(`services.${speciality.id}`) }}
            </span>)
          </div>
          <div class="d-inline-block ml-3">
            <b-btn v-if="authenticated && user.slug !== slug"
                   @click="openMessenger()"
                   variant="secondary">
              <i class="material-icons">email</i>
              <span>{{ $t('professional.sendMsgBtn') }}</span>
            </b-btn>
            <b-btn v-else-if="!authenticated"
                   @click="openSignIn()">
              <i class="material-icons">email</i>
              <span>{{ $t('professional.sendMsgBtn') }}</span>
            </b-btn>
          </div>
          <div v-if="authenticated && user.slug === slug" class="own-profile d-inline-block">
            {{ $t('professional.ownProfile') }}
          </div>
        </b-container>
      </div>
      <section id="header-single-account" :style="headerImage">
        <div v-if="1 === 2 && professional.header_video" class="header-video">
          <iframe frameborder="0" height="100%" width="100%"
                  :src="`https://youtube.com/embed/${professional.header_video}?autoplay=1&controls=0&showinfo=0&autohide=1&mute=1&loop=1&playlist=${professional.header_video}`">
          </iframe>
        </div>
        <div class="overlay"></div>
        <b-container align="left">

        </b-container>
      </section>

      <b-container class="mt-7">
        <b-row class="profile-header">
          <b-col cols="12" md="7" lg="6">
            <div id="profile-wrapper"
                 class="profile-wrapper">
              <div class="profile-photo">
                <page-avatar class="profile"
                             size="100%"
                             :userImage="professional.image"
                             :userName="professional.first_name + ' ' + professional.last_name"></page-avatar>
                <img v-if="professional.membership === 3" width="100" src="https://finefit.s3.eu-north-1.amazonaws.com/images/membership_premium%402x.png" class="membership-premium" />
              </div>
              <div class="user-name">
                <div class="d-inline-block d-sm-block align-top">
                  <h1>
                    {{ professional.first_name }} {{ professional.last_name }}
                    <div v-if="professional.membership === 2"
                         v-b-tooltip.hover
                         :title="$t('professional.verified')"
                         class="verified-badge">
                        <span class="material-icons">
                          verified
                        </span>
                    </div>
                    <div v-else-if="professional.membership === 3"
                         v-b-tooltip.hover
                         :title="$t('professional.premium')"
                         class="premium-badge">
                      <img width="20" src="https://finefit.s3.eu-north-1.amazonaws.com/images/premium_crown.svg" />
                    </div>
                    <div v-else class="free-member">({{ $t('professional.freeMember') }})</div>
                  </h1>
                  <ratings v-if="!_.isUndefined(professional.rating) && !_.isUndefined(professional.rating_count) && professional.membership > 1" :rating="professional.rating" :count="professional.rating_count"></ratings>
                </div>
                <div class="specialities d-inline-block d-sm-block ml-3 ml-sm-0" v-if="!_.isEmpty(professional.specialities)">
                  <div class="font-italic" v-for="speciality in professional.specialities">
                    - {{ $t(`services.${speciality.id}`) }}
                  </div>
                </div>
                <div v-if="1 === 2" class="description">{{ professional.description }}</div>
                <div clas.profile-photos="gender" v-if="!_.isEmpty(professional.gender)">({{ $t(`professional.gender.${professional.gender}`) }})</div>
                <div>
                  <a v-if="authenticated && user.slug !== slug"
                     href="javascript:void(0);"
                     @click="openMessenger()"
                     class="btn btn-primary btn-messenger">
                    <i class="material-icons">email</i>
                    {{ $t('professional.sendMsgBtn') }}
                  </a>
                  <b-btn v-else-if="!authenticated" class="btn-messenger" variant="primary" @click="openSignIn()"><i class="material-icons">email</i>{{ $t('professional.sendMsgBtn') }}</b-btn>
                  <b-btn v-if="authenticated && user.slug !== slug && !isFollowing()"
                         variant="secondary"
                         class="btn-favorite"
                         @click="followProfessional()">
                    <i class="material-icons">
                      star_border
                    </i>
                    {{ $t('professional.followBtn') }}
                  </b-btn>
                  <b-btn v-else-if="authenticated && user.slug !== slug && isFollowing()"
                         variant="secondary"
                         class="btn-favorite"
                         @click="unfollowProfessional()">
                    <i class="material-icons">
                      star_border
                    </i>
                    {{ $t('professional.unfollowBtn') }}
                  </b-btn>
                </div>
              </div>
            </div>

            <div v-if="!_.isUndefined(professional.onlineServices) && !_.isEmpty(professional.onlineServices)" class="mt-5">
              <b-btn v-if="1 === 2" class="btn-offline">Face-to-face services</b-btn>
              <b-btn class="btn-online" @click="scrollToServices">
                {{ $t('onlineServices.scrollBtn') }}
                <span class="material-icons">expand_more</span>
              </b-btn>
            </div>
          </b-col>
          <b-col cols="12" md="5" lg="6">
            <photos v-if="!_.isEmpty(professional.photos)" class="other-photos d-none d-md-block" @selectPhoto="selectPhoto"></photos>
          </b-col>
        </b-row>
        <b-row v-if="(!_.isEmpty(professional.photos) || !_.isEmpty(professional.posts)) && professional.membership > 1">
          <b-col cols="12">
            <ul class="nav nav-tabs">
              <li role="presentation" class="nav-item">
                <a href="javascript:void(0);"
                   @click.prevent="changeTab('main')"
                   class="nav-link"
                   :class="{ active: currentTab === 'main' }">{{ $t('professional.tabs.main') }}</a>
              </li>
              <li role="presentation" class="nav-item">
                <a href="javascript:void(0);"
                   @click.prevent="changeTab('social')"
                   class="nav-link"
                   :class="{ active: currentTab === 'social' }">{{ $t('professional.tabs.social') }}</a>
              </li>
            </ul>
          </b-col>
        </b-row>

        <div id="sticky-anchor"></div>

        <div v-if="currentTab === 'main'">
          <b-row>
            <b-col cols="12" md="7" lg="6" align="left">
              <div class="about d-block d-md-none text-left">
                <h2 v-if="professional.description">{{ $t('professional.aboutTitle') }}</h2>
                <div v-if="professional.description" class="description "><strong>{{ professional.description }}</strong></div>
                <b-btn v-if="professional.description && professional.long_description"
                       v-b-toggle.long-description
                       variant="secondary"
                       class="mt-3">
                  <span v-if="longDescriptionVisible">{{ $t('buttons.showLess') }}</span>
                  <span v-else>{{ $t('buttons.readMore') }}</span>
                </b-btn>

                <b-collapse v-if="professional.long_description"
                            @show="showLongDescription"
                            @hide="hideLongDescription"
                            id="long-description"
                            class="long-description mt-3">
                  <b-card>
                    <div>{{ professional.long_description }}</div>
                  </b-card>
                </b-collapse>
              </div>

              <div class="about d-none d-md-block">
                <h2 v-if="professional.description">{{ $t('professional.aboutTitle') }}</h2>
                <div v-if="professional.description" class="description"><strong>{{ professional.description }}</strong></div>
                <b-btn v-if="professional.description && professional.long_description"
                       v-b-toggle.long-description
                       variant="secondary"
                       class="mt-3">
                  <span v-if="longDescriptionVisible">{{ $t('buttons.showLess') }}</span>
                  <span v-else>{{ $t('buttons.readMore') }}</span>
                </b-btn>

                <b-collapse v-if="professional.long_description"
                            @show="showLongDescription"
                            @hide="hideLongDescription"
                            id="long-description"
                            class="long-description mt-3">
                  <b-card>
                    <div>{{ professional.long_description }}</div>
                  </b-card>
                </b-collapse>
              </div>

              <div v-if="!_.isEmpty(professionalOfflineAds) && !professional.description && professional.membership > 1" class="recommendations">
                <h2>{{ $t('professional.ads.title', { name: professional.first_name }) }}</h2>
                <ad page="profile" training="offline"></ad>
              </div>

              <div v-if="!_.isEmpty(professional.services)">
                <h2>{{ $t('account.servicesTitle') }}</h2>
                <div v-for="(mainLevel, mainIndex) in mainLevelServices" :key="mainIndex" class="service-row">
                  <div class="main-level">
                    <div class="title">{{ $t(`services.${mainLevel}`) }}</div>
                    <div v-for="(service, index) in professional.services" :key="index">

                      <div v-if="service.parent === mainLevel">
                        <div class="sub-level">
                          <div class="title">→ {{ $t(`services.${service.id}`) }}</div>
                          <div class="attribute" v-if="professional.membership > 1">
                            {{ service.description }}
                          </div>
                          <div class="attribute d-inline-block">
                            <b-btn v-if="!_.isEmpty(service.pricing) && professional.membership > 1"
                                   class="d-inline-block"
                                   v-b-toggle="'pricing-' + index"
                                   variant="success">{{ $t('professional.pricing.pricingOptions') }}</b-btn>
                            <div v-if="authenticated && user.slug !== slug" class="d-inline-block">
                              <b-btn variant="secondary" @click="bookService(service.id, index)" v-b-modal.bookModal>{{ $t('buttons.book') }}</b-btn>
                            </div>
                            <div v-else-if="!authenticated" class="d-inline-block">
                              <b-btn variant="secondary" @click="openSignIn()">{{ $t('buttons.book') }}</b-btn>
                            </div>
                            <div v-if="!_.isEmpty(service.pricing) && professional.membership > 1">
                              <b-collapse :id="'pricing-' + index" class="mt-2">
                                <b-card>
                                  <div class="card-text pricing">
                                    <div v-if="!_.isEmpty(service.pricing.firstSessionDiscount)" class="item discount">
                                      <div v-if="Number(service.pricing.firstSessionDiscount) === 100">
                                        {{ $t('professional.pricing.firstSessionFree') }}
                                      </div>
                                      <div v-else>
                                        {{ $t('professional.pricing.firstSessionDiscount', { percent: service.pricing.firstSessionDiscount }) }}
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.priceDurations)" class="item durations">
                                      <div v-for="duration in service.pricing.priceDurations">
                                        <div v-if="!_.isUndefined(duration.price) && !_.isUndefined(duration.duration) && !_.isEmpty(duration.duration) && !_.isUndefined(duration.duration.label)">
                                          €{{ duration.price }} for {{ duration.duration.label }}
                                        </div>
                                        <div v-else-if="!_.isUndefined(duration.price)">
                                          €{{ duration.price }}
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.priceSessions)" class="item durations">
                                      <div v-for="session in service.pricing.priceSessions">
                                        <div v-if="!_.isUndefined(session.price) && !_.isUndefined(session.option) && !_.isEmpty(session.option) && !_.isUndefined(session.option.label)">
                                          €{{ session.price }} for {{ session.option.label }}
                                        </div>
                                        <div v-else-if="!_.isUndefined(session.price)">
                                          €{{ session.price }}
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.pricePackages)" class="item packages">
                                      {{ $t('professional.pricing.packages') }}:
                                      <ul>
                                        <li v-for="pricePackage in service.pricing.pricePackages">
                                          <i class="material-icons">star</i> {{ pricePackage.text }}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </b-card>
                              </b-collapse>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col cols="12" md="5" lg="6" align="left">
              <div v-if="!_.isEmpty(professionalOfflineAds) && professional.description && professional.membership > 1" class="recommendations">
                <h2>{{ $t('professional.ads.title', { name: professional.first_name }) }}</h2>
                <ad page="profile" training="offline"></ad>
              </div>

              <div v-if="!_.isUndefined(professional.locations) && !_.isEmpty(professional.locations) && !_.isUndefined(professional.locations.places) && professional.locations.places.length > 0" class="mb-5">
                <google-map :locations="professional.locations" />
              </div>

              <div v-if="!_.isUndefined(professional.certificates) && !_.isEmpty(professional.certificates)">
                <h2>{{ $t('account.certificatesTitle') }}</h2>
                <b-row v-for="(certificate, index) in professional.certificates" :key="index" class="certificate-row">
                  <b-col v-if="!_.isEmpty(certificate.file)">
                    <img :src="certificate.file">
                  </b-col>
                  <b-col>
                    <div class="title">{{ certificate.title }}</div>
                    <div v-if="certificate.id">ID: {{ certificate.id }}</div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>

      <div v-if="currentTab === 'main' && !_.isUndefined(professional.onlineServices) && !_.isEmpty(professional.onlineServices)" class="online-services" id="online-services">
        <header class="online-services-header">
          <b-container>
            <div class="text-center">
              <h2 class="text-center">{{ $t('onlineServices.offerServices') }}</h2>
              <b-btn v-if="authenticated && user.slug !== slug"
                     @click="openMessenger()"
                     variant="secondary">
                <i class="material-icons">email</i>
                {{ $t('professional.sendMsgBtn') }}
              </b-btn>
              <b-btn v-else-if="!authenticated"
                     @click="openSignIn()">
                <i class="material-icons">email</i>
                {{ $t('professional.sendMsgBtn') }}
              </b-btn>
            </div>
          </b-container>
        </header>
        <b-container>

          <b-row>
            <b-col cols="12" md="6" lg="6" align="left">
              <div v-if="!_.isEmpty(professional.onlineServices)">
                <h2><span class="material-icons">forum</span>{{ $t('onlineServices.servicesOnlineTitle') }}</h2>
                <div v-for="(mainLevel, mainIndex) in mainLevelOnlineServices" :key="mainIndex" class="service-row">
                  <div class="main-level">
                    <div class="title">{{ $t(`services.${mainLevel}`) }}</div>
                    <div v-for="(service, index) in professional.onlineServices" :key="index">
                      <div v-if="service.parent === mainLevel">
                        <div class="sub-level">
                          <div class="title">→ {{ $t(`services.${service.id}`) }}</div>
                          <div class="attribute" v-if="professional.membership > 1">
                            {{ service.description }}
                          </div>
                          <div class="attribute d-inline-block">
                            <div v-if="!_.isUndefined(service.websites) && !_.isEmpty(service.websites)">
                              <div class="websites-title mt-3 mb-3">{{ $t('onlineServices.websitesTitle') }}</div>
                              <div v-for="(website, index2) in service.websites" :key="index2" class="website-item">
                                <a :href="validateUrl(website.url)" :title="$t('onlineServices.websiteLinkTitle', { url: website.url })" target="_blank" class="btn website mb-3">{{ $t('onlineServices.openWebsiteBtn') }}</a>
                                <div class="website-description">{{ website.description }}</div>
                              </div>
                            </div>
                            <b-btn v-if="!_.isEmpty(service.pricing) && professional.membership > 1"
                                   class="d-inline-block"
                                   v-b-toggle="'pricing-' + index"
                                   variant="success">{{ $t('professional.pricing.pricingOptions') }}</b-btn>
                            <div v-if="!_.isEmpty(service.pricing) && professional.membership > 1">
                              <b-collapse :id="'pricing-' + index" class="mt-2">
                                <b-card>
                                  <div class="card-text pricing">
                                    <div v-if="!_.isEmpty(service.pricing.firstSessionDiscount)" class="item discount">
                                      <div v-if="Number(service.pricing.firstSessionDiscount) === 100">
                                        {{ $t('professional.pricing.firstSessionFree') }}
                                      </div>
                                      <div v-else>
                                        {{ $t('professional.pricing.firstSessionDiscount', { percent: service.pricing.firstSessionDiscount }) }}
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.priceDurations)" class="item durations">
                                      <div v-for="duration in service.pricing.priceDurations">
                                        <div v-if="!_.isUndefined(duration.price) && !_.isUndefined(duration.duration) && !_.isEmpty(duration.duration) && !_.isUndefined(duration.duration.label)">
                                          €{{ duration.price }} for {{ duration.duration.label }}
                                        </div>
                                        <div v-else-if="!_.isUndefined(duration.price)">
                                          €{{ duration.price }}
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.priceSessions)" class="item durations">
                                      <div v-for="session in service.pricing.priceSessions">
                                        <div v-if="!_.isUndefined(session.price) && !_.isUndefined(session.option) && !_.isEmpty(session.option) && !_.isUndefined(session.option.label)">
                                          €{{ session.price }} for {{ session.option.label }}
                                        </div>
                                        <div v-else-if="!_.isUndefined(duration.price)">
                                          €{{ session.price }}
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="!_.isEmpty(service.pricing.pricePackages)" class="item packages">
                                      {{ $t('professional.pricing.packages') }}:
                                      <ul>
                                        <li v-for="pricePackage in service.pricing.pricePackages">
                                          <i class="material-icons">star</i> {{ pricePackage.text }}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </b-card>
                              </b-collapse>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="6" align="left">
              <div v-if="!_.isEmpty(professionalOnlineAds) && professional.description && professional.membership > 1" class="recommendations">
                <h2>{{ $t('professional.ads.title', { name: professional.first_name }) }}</h2>
                <ad page="profile" training="online"></ad>
              </div>

              <div v-if="!_.isUndefined(professional.onlineLanguages) && !_.isEmpty(professional.onlineLanguages)" class="languages">
                <h2><span class="material-icons">language</span>{{ $t('onlineServices.onlineLanguagesTitle') }}</h2>
                <p>{{ $t('onlineServices.onlineLanguagesDesc') }}</p>
                <div v-for="(lang, index) in professional.onlineLanguages" :key="index">
                  <strong>{{ languages[lang].name }}</strong> ({{ languages[lang].nativeName }})
                </div>
              </div>

              <div v-if="!_.isUndefined(professional.onlineMethods) && !_.isEmpty(professional.onlineMethods)" class="methods">
                <h2><span class="material-icons">library_books</span>{{ $t('onlineServices.onlineMethodsTitle') }}</h2>
                <div v-for="(method, index) in professional.onlineMethods"
                     :key="index"
                     variant="secondary"
                     class="training-method d-block d-md-inline-block mb-3"
                     :class="{ 'mr-md-3': index < (professional.onlineMethods.length - 1) }">
                  <span class="material-icons">
                    {{ $t(`onlineServices.methods.${method}.icon`) }}
                  </span>
                  <div>{{ $t(`onlineServices.methods.${method}.title`) }}</div>
                </div>
              </div>
            </b-col>
          </b-row>

        </b-container>
      </div>

      <b-container>
        <div v-if="currentTab === 'main'">
          <b-row>
            <b-col cols="12" md="5" lg="6" align="left">
              <div v-if="!_.isEmpty(professional.photos)" class="d-block d-md-none">
                <h2>{{ $t('professional.photosTitle') }}</h2>
                <photos :large="true"
                        class="mx-auto"
                        @selectPhoto="selectPhoto"></photos>
              </div>

              <div id="ratings-reviews" v-if="professional.membership > 1">
                <h2>{{ $t('professional.reviews.title') }}</h2>
                <reviews :reviews="professional.reviews"
                         @disallowReview="disallowReview"></reviews>

                <div v-if="reviewSuccess">
                  <response :text="$t('professional.reviews.publishSuccess')"
                            variant="success"></response>
                </div>
                <div v-else-if="authenticated && user.slug !== slug">
                  <div v-if="isReviewLoading" class="text-center">
                    <preloader></preloader>
                  </div>
                  <form @submit.prevent="addReview()"
                        v-else-if="ownReview && allowReview"
                        class="own-review mt-3">
                    <h4>{{ $t('professional.reviews.userReviewTitle') }}</h4>
                    <b-form-group class="rating">
                      <input v-model="reviewForm.rating" type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="Awesome - 5 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star4half" name="rating" value="4.5" /><label class="half" for="star4half" title="Pretty good - 4.5 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="Pretty good - 4 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star3half" name="rating" value="3.5" /><label class="half" for="star3half" title="Meh - 3.5 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="Meh - 3 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star2half" name="rating" value="2.5" /><label class="half" for="star2half" title="Kinda bad - 2.5 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="Kinda bad - 2 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star1half" name="rating" value="1.5" /><label class="half" for="star1half" title="Meh - 1.5 stars"></label>
                      <input v-model="reviewForm.rating" type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="Sucks big time - 1 star"></label>
                      <input v-model="reviewForm.rating" type="radio" id="starhalf" name="rating" value="0.5" /><label class="half" for="starhalf" title="Sucks big time - 0.5 stars"></label>
                    </b-form-group>

                    <textarea id="review"
                              class="form-control mb-0"
                              v-model="reviewForm.message"
                              :placeholder="$t('professional.reviews.placeholder')"
                              :rows="3"
                              maxlength="300"
                              required></textarea>
                    <div class="char-count text-right mb-3"><strong>{{ reviewForm.message.length }}</strong> / {{ reviewLimit }}</div>

                    <div align="right" class="mt-3">
                      <b-btn variant="secondary" @click="cancelOwnReview()">{{ $t('professional.reviews.cancelBtn') }}</b-btn>
                      <b-btn v-if="!_.isNil(reviewForm.rating)" type="submit" variant="primary">{{ $t('professional.reviews.publishBtn') }}</b-btn>
                      <b-btn v-else variant="primary" disabled>{{ $t('professional.reviews.publishBtn') }}</b-btn>
                    </div>
                  </form>
                  <b-btn v-else-if="allowReview"
                         variant="secondary"
                         @click="addOwnReview()">{{ $t('professional.reviews.addBtn') }}</b-btn>
                </div>
                <div v-else-if="authenticated && user.slug === slug">
                  {{ $t('professional.reviews.ownReviews') }}
                </div>
                <div v-else>
                  {{ $t('professional.reviews.accessDenied') }}
                </div>
                <div v-if="!_.isEmpty(errors)" class="mt-3">
                  <response :items="errors"></response>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="currentTab === 'social'">
          <b-row class="social-activities">
            <b-col v-if="!_.isEmpty(photos)"
                   cols="12"
                   :class="{ 'col-md-5': !_.isEmpty(posts) }"
                   order="2" order-md="1">
              <h2>{{ $t('professional.social.instagram.title') }}</h2>
              <div id="photos"
                   class="text-left"
                   :class="{ 'row': _.isEmpty(posts) }">
                <div v-for="(photo, index) in photos"
                     :key="index"
                     class="mb-3"
                     :class="{ 'col-md-6': _.isEmpty(posts) }">
                  <a href="javascript:void(0);"
                     @click.prevent="selectPhoto(index)"
                     class="photo d-block mb-3">
                    <img :src="photo.large" />
                  </a>
                  <p>
                    {{ photo.caption }}
                  </p>
                  <p align="center">
                    <b-btn variant="secondary"
                           :href="photo.link"
                           target="_blank"
                           class="btn-instagram mx-auto">{{ $t('professional.social.instagram.viewBtn') }}</b-btn>
                  </p>
                  <hr />
                </div>
                <div class="mt-2">{{ $t('professional.social.instagram.source') }}: <a :href="`https://www.instagram.com/${professional.photos.user_name}`" target="_blank">instagram.com/{{ professional.photos.user_name }}</a></div>
              </div>
            </b-col>
            <b-col v-if="!_.isEmpty(posts)"
                   cols="12"
                   :class="{ 'col-md-7': !_.isEmpty(photos) }"
                   order="1" order-md="2">
              <h2>{{ $t('professional.social.facebook.title') }}</h2>
              <div id="posts"
                   class="text-left"
                   :class="{ 'row': _.isEmpty(photos) }">
                <div v-for="(post, index) in posts"
                     :key="index"
                     class="mt-3"
                     :class="{ 'col-md-6': _.isEmpty(photos) }">
                  <div class="mb-3">{{ frontEndDateFormat(post.created_time) }}. {{ $t('professional.social.facebook.originalPost') }}: <a :href="`https://www.facebook.com/${post.id}`" target="_blank" class="btn-facebook"><img height="20" src="@/assets/images/logo-fb.svg" />{{ $t('professional.social.facebook.viewBtnShort') }}</a></div>
                  <strong>{{ post.message }}</strong>
                  <hr />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>

      <b-modal id="bookModal" :title="$t('buttons.book')">
        <div class="modal-body">
          <Book :service="selectedService"
                :serviceChild="selectedServiceChild"
                :professionalSlug="slug"
                :locations="professional.locations"></Book>
        </div>
        <div slot="modal-footer">
          <p></p>
        </div>
      </b-modal>

      <b-modal id="photosModal" ref="photosModal" :title="$t('professional.social.instagram.modalTitle')">
        <div class="modal-body">
          <div v-if="!_.isEmpty(selectedPhoto)" class="mx-auto">
            <div class="image">
              <img :src="selectedPhoto.large" class="large" />

              <b-btn variant="secondary" class="btn-prev" @click="prevPhoto()">
                <i class="material-icons">
                  navigate_before
                </i>
              </b-btn>
              <b-btn variant="secondary" class="btn-next" @click="nextPhoto()">
                <i class="material-icons">
                  navigate_next
                </i>
              </b-btn>
            </div>
          </div>
          <div v-else>
            {{ $t('professional.social.instagram.selectPhoto') }}
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <div v-if="!_.isEmpty(selectedPhoto)" class="mx-auto">
            <p>{{ selectedPhoto.caption }}</p>
            <p><b-btn variant="secondary" :href="selectedPhoto.link" target="_blank" class="btn-instagram">{{ $t('professional.social.instagram.viewBtn') }}</b-btn></p>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <svg style="width: 150px; height: auto; display: block; margin: 0 auto;" height="442pt" viewBox="0 -40 442 442" width="442pt" xmlns="http://www.w3.org/2000/svg"><path d="m97.617188 35.039062c0-5.582031-4.167969-10.105468-9.308594-10.105468-5.136719 0-9.304688 4.523437-9.304688 10.105468 0 5.578126 4.167969 10.105469 9.304688 10.105469 5.140625 0 9.308594-4.527343 9.308594-10.105469zm0 0"/><path d="m44.621094 35.039062c0-5.582031-4.164063-10.105468-9.304688-10.105468s-9.304687 4.523437-9.304687 10.105468c0 5.578126 4.164062 10.105469 9.304687 10.105469s9.304688-4.527343 9.304688-10.105469zm0 0"/><path d="m220.949219 235.425781c5.601562 0 9.050781-3.101562 9.050781-10v-26.5c0-6.902343-3.449219-10-9.050781-10-5.597657 0-8.949219 3.097657-8.949219 10v26.5c0 6.898438 3.351562 10 8.949219 10zm0 0"/><path d="m0 362h442v-278h-442zm259.847656-137.363281 23.097656-45.292969c1.195313-2.492188 3.738282-4.050781 6.5-3.976562 2.703126 0 7.800782 2.347656 7.800782 5.949218-.035156.691406-.203125 1.371094-.5 2l-17.695313 35.683594h8.949219v-7.378906c0-3.296875 3.601562-4.699219 7.5-4.699219s7.5 1.402344 7.5 4.699219v7.378906h4.550781c3.199219 0 4.800781 3.398438 4.800781 7s-2.402343 7-4.800781 7h-4.550781v10.625c0 3.199219-3.601562 4.800781-7.5 4.800781s-7.5-1.601562-7.5-4.800781v-10.625h-23.753906c-1.429688.070312-2.824219-.480469-3.820313-1.511719-.996093-1.03125-1.496093-2.441406-1.378906-3.871093.019531-1.042969.292969-2.066407.800781-2.980469zm-62.847656-25.714844c0-17.199219 10.648438-23.601563 24.449219-23.601563s24.550781 6.402344 24.550781 23.601563v26.5c0 17.199219-10.75 23.601563-24.550781 23.601563s-24.449219-6.402344-24.449219-23.601563zm-66.550781 25.714844 23.101562-45.292969c1.191407-2.492188 3.738281-4.050781 6.5-3.976562 2.699219 0 7.796875 2.347656 7.796875 5.949218-.035156.691406-.203125 1.371094-.5 2l-17.695312 35.683594h8.347656v-7.378906c0-3.296875 4.101562-4.699219 8-4.699219s8 1.402344 8 4.699219v7.378906h4.152344c3.199218 0 4.800781 3.398438 4.800781 7s-2.402344 7-4.800781 7h-4.152344v10.625c0 3.199219-4.101562 4.800781-8 4.800781s-8-1.601562-8-4.800781v-10.625h-23.148438c-1.433593.070312-2.824218-.480469-3.824218-1.511719-.996094-1.03125-1.496094-2.441406-1.378906-3.871093.019531-1.042969.292968-2.066407.800781-2.980469zm0 0"/><path d="m150.609375 35.039062c0-5.582031-4.167969-10.105468-9.304687-10.105468-5.140626 0-9.308594 4.523437-9.308594 10.105468 0 5.578126 4.167968 10.105469 9.308594 10.105469 5.136718 0 9.304687-4.527343 9.304687-10.105469zm0 0"/><path d="m0 70h442v-70h-442zm141.300781-59.066406c12.851563 0 23.304688 10.8125 23.304688 24.097656 0 13.289062-10.453125 24.109375-23.304688 24.109375-12.851562 0-23.300781-10.8125-23.300781-24.101563 0-13.292968 10.453125-24.105468 23.300781-24.105468zm-52.992187 0c12.847656 0 23.304687 10.8125 23.304687 24.097656 0 13.289062-10.457031 24.109375-23.304687 24.109375-12.851563 0-23.308594-10.8125-23.308594-24.101563 0-13.292968 10.460938-24.105468 23.308594-24.105468zm-52.996094 0c12.851562 0 23.308594 10.8125 23.308594 24.097656 0 13.289062-10.457032 24.109375-23.308594 24.109375-12.847656 0-23.300781-10.8125-23.300781-24.101563 0-13.292968 10.453125-24.105468 23.304687-24.105468zm0 0"/></svg>
      <h1 class="text-center mt-3">{{ $t('notFound') }}</h1>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { frontEndDateFormat } from '@/util/date'
  import EventBus from '@/util/eventBus'
  import langList from '@/languages/languages.json'
  import { scrollTo } from '@/util/dom.js'

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'professionals-single',
    components: {
      PageAvatar: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/PageAvatar')}),
      Book: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Book')}),
      GoogleMap: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/GoogleMap')}),
      Ratings: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Ratings')}),
      Reviews: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Reviews')}),
      Ad: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./Ad')}),
      Photos: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Photos')})
    },
    data () {
      return {
        errors: [],
        reviewSuccess: null,
        ownReview: false,
        selectedService: null,
        selectedServiceChild: null,
        selectedServiceChildChild: null,
        reviewForm: {
          rating: null,
          message: ''
        },
        longDescriptionVisible: false,
        slug: null,
        isLoading: true,
        photosLen: null,
        photosRemLen: null,
        selectedPhoto: {},
        selectedPhotoIndex: null,
        currentTab: 'main',
        reviewLimit: 300,
        isConversationLoading: false,
        isReviewLoading: false,
        siteTitle: 'Test 1',
        siteDesc: 'Desc 1',
        allowReview: true,
        section: '',
        languages: langList,
        contentLoaded: false
      }
    },
    // metaInfo: {
    //   title: 'Test',
    //   titleTemplate: '%s - Yay!',
    //   htmlAttrs: {
    //     lang: 'en',
    //     amp: true
    //   }
    // },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated',
        professional: 'professionals/professional',
        userConversations: 'messenger/userConversations',
        professionalOfflineAds: 'professionals/professionalOfflineAds',
        professionalOnlineAds: 'professionals/professionalOnlineAds',
        selectedProfessional: 'messenger/selectedProfessional'
      }),
      mainLevelServices: function () {
        if (!_.isEmpty(this.professional)) {
          if (!_.isEmpty(this.professional.services)) {
            let services = this.professional.services
            let mainLevelArr = _.uniq(_.map(services, 'parent'), function(x){
              return x.parent;
            })
            return mainLevelArr
          }
        }
        return []
      },
      mainLevelOnlineServices: function () {
        if (!_.isEmpty(this.professional)) {
          if (!_.isEmpty(this.professional.onlineServices)) {
            let onlineServices = this.professional.onlineServices
            let mainLevelArr = _.uniq(_.map(onlineServices, 'parent'), function(x){
              return x.parent;
            })
            return mainLevelArr
          }
        }
        return []
      },
      headerImage: function () {
        if (!_.isEmpty(this.professional)) {
          if (this.professional.header_image) {
            return `background-image: url(${this.professional.header_image})`
          }
        }
        return ''
      },
      photos: function () {
        if (!_.isEmpty(this.professional)) {
          if (!_.isEmpty(this.professional.photos)) {
            if (this.professional.photos.photos.length > 0) {
              this.photosLen = this.professional.photos.photos.length
              this.photosRemLen = Math.abs(this.photosLen - 6)
              return this.professional.photos.photos
            }
          }
        }
        return []
      },
      slicedPhotos: function () {
        if (this.photos.length > 0) {
          return this.photos.slice(0, 6)
        }
        return []
      },
      posts: function () {
        if (!_.isEmpty(this.professional)) {
          if (!_.isEmpty(this.professional.posts)) {
            if (this.professional.posts.posts.length > 0) {
              return this.professional.posts.posts
            }
          }
        }
        return []
      },
    },
    methods: {
      ...mapActions({
        getProfessionalInfo: 'professionals/getProfessionalInfo',
        getProfessionalOfflineAds: 'professionals/getProfessionalOfflineAds',
        getProfessionalOnlineAds: 'professionals/getProfessionalOnlineAds',
        addProfessionalReview: 'professionals/addProfessionalReview',
        saveReview: 'saveReview',
        submitFollowProfessional: 'professionals/followProfessional',
        submitUnfollowProfessional: 'professionals/unfollowProfessional',
        setAuthRedirect: 'auth/authRedirect',
        getConversationMessages: 'messenger/getMessages'
      }),
      frontEndDateFormat: frontEndDateFormat,
      scroll: scrollTo,
      scrollToServices: function () {
        let target = document.getElementById('online-services')
        if (target) {
          this.scroll(document.scrollingElement || document.documentElement, 'scrollTop', '', window.pageYOffset, target.offsetTop - 50, 700, true)
        }
      },
      openSignIn: function () {
        // Set redirect param to save this pathname from URL to redirect back here after sign in
        // this.$router.push({ query: { redirect: '' }})

        // Set auth redirect to false, to not redirect anywhere after sign in
        this.setAuthRedirect(false)
        this.$root.$emit('bv::show::modal', 'signInModal')
      },
      bookService: function (service, serviceChild = null, serviceChildChild = null) {
        this.selectedService = this.$i18n.t(`services.${service}`)
        if (!_.isEmpty(serviceChild)) {
          this.selectedServiceChild = this.$i18n.t(`services.${serviceChild}`)
        }
        if (!_.isEmpty(serviceChildChild)) {
          this.selectedServiceChildChild = this.$i18n.t(`services.${serviceChildChild}`)
        }
        this.prepareMessenger()
      },
      prepareMessenger () {
        let conversations = this.userConversations
        let proId = this.professional.id
        let conversation = {}

        for (let i = 0; i < conversations.length; i++) {
          if (!_.isUndefined(conversations[i].users) && !_.isEmpty(conversations[i].users)) {
            // Check if there is an existing conversation with only this professional
            if (conversations[i].users.length === 1 && _.findIndex(conversations[i].users, { id: proId }) > -1) {
              conversation = conversations[i]
            }
          }
        }

        if (!_.isEmpty(conversation)) {
          // Load existing conversation
          this.$store.commit('messenger/SET_SELECTED_CONVERSATION', conversation)
          let payload = {
            conversation_id: conversation.conversation_id
          }
          this.getConversationMessages({ payload: payload, context: this })
        } else {

          let payload = {
            id: this.professional.id,
            name: `${this.professional.first_name} ${this.professional.last_name}`,
            image: this.professional.image
          }
          this.$store.commit('messenger/SET_SELECTED_PROFESSIONAL', payload)
        }
      },
      openMessenger: function () {
        this.prepareMessenger()
        EventBus.$emit('openMessenger', 1)
      },
      followProfessional: function () {
        this.submitFollowProfessional({ payload: this.slug, context: this })
      },
      unfollowProfessional: function () {
        this.submitUnfollowProfessional({ payload: this.slug, context: this })
      },
      addOwnReview: function () {
        this.ownReview = true
      },
      cancelOwnReview: function () {
        this.ownReview = false
      },
      addReview: function () {
        let payload = {
          message: this.reviewForm.message,
          rating: parseFloat(this.reviewForm.rating),
          slug: this.slug
        }
        this.addProfessionalReview({ payload: payload, context: this })
      },
      showLongDescription: function () {
        this.longDescriptionVisible = true
      },
      hideLongDescription: function () {
        this.longDescriptionVisible = false
      },
      selectPhoto: function (index) {
        this.selectedPhotoIndex = index
        this.selectedPhoto = _.assign({}, this.selectedPhoto, this.photos[index])
        this.$refs['photosModal'].show()
      },
      nextPhoto: function () {
        let index = this.selectedPhotoIndex
        let len = this.photosLen
        index += 1
        if (index > (len - 1)) {
          index = 0
        }
        this.selectPhoto(index)
      },
      prevPhoto: function () {
        let index = this.selectedPhotoIndex
        let len = this.photosLen
        index -= 1
        if (index < 0) {
          index = len - 1
        }
        this.selectPhoto(index)
      },
      changePhoto: function (event) {
        if (this.photos.length > 0) {
          if (event.keyCode === 37) {
            this.prevPhoto()
          } else if (event.keyCode === 39) {
            this.nextPhoto()
          }
        }
      },
      changeTab: function (tab) {
        this.currentTab = tab
      },
      isFollowing: function () {
        if (!_.isEmpty(this.user)) {
          if (this.user.following && this.user.following.length > 0) {
            let arr = Object.values(this.user.following)
            let following = arr.indexOf(this.professional.id)
            if (following > -1) {
              return true
            }
          }
        }
        return false
      },
      getSpecialitiesStr: function () {
        let specialitiesStr = ''
        for (let i = 0; i < this.professional.specialities.length; i++) {
          if (i === 0) {
            specialitiesStr = this.$i18n.t(`services.${this.professional.specialities[i].id}`)
          } else {
            specialitiesStr += ', ' + this.$i18n.t(`services.${this.professional.specialities[i].id}`)
          }
        }
        return specialitiesStr
      },
      checkLang () {
        if (!_.isEmpty(this.$route.params) && !_.isUndefined(this.$route.params.lang)) {
          let lang = this.$route.params.lang
          if (!_.isUndefined(lang) && (lang === 'en' || lang === 'fi')) {
            this.lang = lang
            this.$i18n.i18next.changeLanguage(lang)

            if (this.authenticated) {
              let payload = {
                lang: lang
              }
              this.saveUserLang({payload: payload})
            }
          }
        }
      },
      disallowReview () {
        this.allowReview = false
      },
      setMetaTags (data) {
        // Customize meta tags

        if (!_.isUndefined(data) && !_.isEmpty(data)) {
          // let specialitiesStr = await this.getSpecialitiesStr()

          let siteTitle = `${data.first_name} ${data.last_name} | Fine.Fit` // ${specialitiesStr} |
          let siteDesc = `${data.first_name} ${data.last_name} `

          if (data.description) {
            siteDesc += `- ${data.description}`
          } else {
            siteDesc += `- ${this.$i18n.t('professional.metaDesc')}`
          }

          let titleEl = document.querySelector('head title')
          let descEl = document.querySelector('head meta[name="description"]')

          // titleEl.textContent = siteTitle
          // descEl.setAttribute('content', siteDesc)

          document.title = siteTitle
          descEl.setAttribute('content', siteDesc)

          let imageEl = document.querySelector('head meta[property="og:image"]')
          imageEl.setAttribute('content', data.image)
        } else {
          // Default tags for non existing professional
          let siteTitle = `404 | Fine.Fit` // ${specialitiesStr} |
          let siteDesc = `404 error`

          let titleEl = document.querySelector('head title')
          let descEl = document.querySelector('head meta[name="description"]')

          // titleEl.textContent = siteTitle
          // descEl.setAttribute('content', siteDesc)

          document.title = siteTitle
          descEl.setAttribute('content', siteDesc)
        }

        window.history.pushState({}, document.title, document.location.href)
      },
      stickyHeader () {
        let anchor = document.getElementById('sticky-anchor')
        let stickyHeader = document.getElementById('sticky-header')

        if (anchor && stickyHeader) {
          anchor = anchor.offsetTop

          if (window.pageYOffset > anchor) {
            stickyHeader.classList.add('sticky')
          } else {
            stickyHeader.classList.remove('sticky')
          }
        }
      },
      validateUrl (url) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i') // fragment locator

        url = 'https://fine.fit'
        let isValid = !pattern.test(url)
        console.log('isValid', isValid)

        if (isValid) {
          return url
        } else {
          return `http://${url}`
        }
      }
    },
    mounted () {
      let urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('redirect')) {
        if (urlParams.get('redirect') === 'false') {
          // Set auth redirect to false, to not redirect anywhere after sign in
          this.setAuthRedirect(false)
        }
      }
      this.checkLang()

      let parent = this
      window.onscroll = function() {
        parent.stickyHeader()
      }
    },
    created () {
      // let payload = this.$route.params.professionalId
      this.slug = this.$route.params.slug
      this.getProfessionalInfo({ payload: this.slug, context: this })
      this.getProfessionalOfflineAds({ payload: this.slug, context: this })
      this.getProfessionalOnlineAds({ payload: this.slug, context: this })
    },
    watch: {
      contentLoaded () {
        let parent = this
        if (this.contentLoaded) {
          if (!_.isUndefined(this.$route.name)) {
            if (this.$route.name === 'OnlineProfessionalsSingle.en' || this.$route.name === 'OnlineProfessionalsSingle.fi') {
              this.section = 'online'
              setTimeout(function () {
                parent.scrollToServices()
              }, 1000)
            }
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  #professionals-single {
    h1, h2 {
      font-weight: normal;
      text-align: left;
    }
    ul {
      list-style-type: none;
      padding: 0;
    }
    li {
      /*display: inline-block;*/
      /*margin: 0 10px;*/
    }
    a:not(.btn-primary) {
      color: #42b983;
    }

    .photo-wrapper {
      margin-right: 2rem;

      img {
        border: 1px solid #ccc;
      }
    }

    ul.nav-tabs {
      margin-bottom: 1.5rem;

      li:first-child {
        margin-left: 0;
      }

      li.nav-item {
        a.nav-link {
          color: black;

          &.active {
            border: none;
            border-bottom: 2px solid black;
          }
        }
      }
    }

    .basic-info {
      text-align: left;

      .name {
        font-weight: bold;
      }
      .specialities {
        font-weight: bold;
      }
    }

    .service-row {
      text-align: left;
      padding-bottom: 2rem;
      border-bottom: 1px solid #ddd;

      .main-level {
        & > .title {
          font-weight: bold;
          font-size: 120%;
        }

        .sub-level {
          margin-left: 1rem;

          .title {
            font-weight: bold;
          }
          .attribute {
            margin-left: 1.4rem;
          }
          .pricing {
            .item {
              border-bottom: 2px solid black;
              margin-bottom: 0.5rem;
              padding-bottom: 0.5rem;

              &.discount {
                font-weight: bold;
              }

              ul {
                margin-bottom: 0;

                li {
                  i {
                    font-size: 1.1rem;
                    vertical-align: middle;
                    margin-top: -3px;
                  }
                }
              }
            }

          }
        }
      }
    }

    .certificate-row {
      text-align: left;
      padding-bottom: 2rem;
      border-bottom: 1px solid #ddd;

      .title {
        font-weight: bold;
        font-size: 120%;
      }
    }

    .sub-service {

    }

    @include media-breakpoint-down(xs) {
      height: auto;
    }

    #header-single-account {
      position: relative;
      min-height: 350px;
      background-repeat: no-repeat;
      background-position: center center;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      padding: 0;
      background-image: url(https://finefit.s3.eu-north-1.amazonaws.com/images/header_placeholder.jpg);

      .header-video {
        position: absolute;
        height: 100%;
        width: 100%;
        overflow: hidden;
        z-index: 0;

        iframe {
          position: absolute;
          height: 178vh;
          width: 100vw;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          bottom: 0;
          z-index: -1;
        }
      }

      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));

        @include media-breakpoint-down(xs) {
          /*display: none;*/
        }
      }

      .container {
        position: relative;
        height: 350px;


      }

      @include media-breakpoint-down(xs) {
        min-height: auto;
        /*background: none;*/
        margin-bottom: 0;
      }
    }

    .profile-header {
      margin-bottom: 3rem;
    }
    .profile-wrapper {
      display: flex;
      width: auto;
      margin-top: -7rem;
      background: white;

      .profile-photo {
        position: relative;
        display: inline-flex;
        vertical-align: top;
        max-height: 200px;

        .membership-premium {
          position: absolute;
          right: -1.2rem;
          bottom: -1.2rem;
          z-index: 1;

          @include media-breakpoint-down(xs) {
            right: -0.8rem;
            bottom: -0.8rem;
          }
        }

        .avatar {
          min-width: 200px !important;
          min-height: 200px !important;
          width: 100% !important;
          height: 100% !important;

          .avatar-image {
            height: 100% !important;
            width: 100% !important;
            max-width: 200px;
            img {
              height: 100%;
              width: auto;
            }

            @include media-breakpoint-down(md) {
              max-width: 100%;
              width: 100%!important;
              height: 100% !important;

              img {
                width: 100%;
                height: auto;
              }
            }

            @include media-breakpoint-down(sm) {
              width: 100% !important;
              max-width: 200px;
              height: 100% !important;
              img {
                height: 100%;
                width: auto;
              }
            }

            @include media-breakpoint-down(xs) {
              max-width: 100%;

              img {
                width: 100%;
                height: auto;
              }
            }
          }
        }

        @include media-breakpoint-down(md) {
          /*max-height: 150px;*/
        }

        @include media-breakpoint-down(sm) {
          max-height: 200px;
        }

        @include media-breakpoint-down(xs) {
          display: block;
          max-height: 100%;
        }
      }
      .user-name {
        display: inline-block;
        background: white;
        padding: 1rem;
        text-align: left;
        word-break: break-all;
        max-width: 300px;
        vertical-align: bottom;

        h1 {
          display: inline-block;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: black;
          font-size: 1.5rem;
          font-weight: normal;
          text-align: left;
          margin: 0;
          position: relative;

          .verified-badge {
            position: absolute;
            right: -1.9rem;
            top: 0rem;
            z-index: 3;

            span.material-icons {
              color: #6ecdff;
              background: white;
              border-radius: 50%;
              font-size: 1.7rem;
            }
          }

          .premium-badge {
            position: absolute;
            right: -1.6rem;
            top: -0.2rem;
            z-index: 3;

            img {
              width: 20px;
              height: auto;
            }
          }

          .free-member {
            display: block;
            font-size: 0.8rem;
            font-style: italic;
            margin-top: 0.2rem;
            margin-bottom: 0.5rem;
          }

          @include media-breakpoint-down(sm) {
            font-size: 1.2rem;
          }
        }

        .specialities {
          font-size: 80%;
        }

        @include media-breakpoint-down(sm) {
          display: table-cell;
          width: 100%;
          font-size: 0.8rem;
        }

        @include media-breakpoint-down(xs) {
          width: 50%;
        }
      }

      @include media-breakpoint-down(sm) {
        .avatar-image {
          min-height: 200px;
        }
        .avatar-generated {
          min-height: 200px;
        }
      }

      @include media-breakpoint-down(xs) {
        display: block;
        margin: 0 auto;
        margin-top: -7rem;
        transform: unset;
        max-width: 300px;

        .avatar,
        .avatar-image {
          min-height: 300px;
        }

        .avatar-generated {
          min-height: 300px;
        }
      }
    }
    .other-photos {
      margin-top: -7rem;
      background: white;

      @include media-breakpoint-down(sm) {
        margin-top: 0;
      }
    }

    .btn-messenger {
      width: 100%;
      margin-top: 1rem;
      vertical-align: middle;

      i {
        font-size: 1rem;
        margin-top: -2px;
        vertical-align: middle;
      }
    }

    .btn-favorite {
      width: 100%;
      margin-top: 1rem;
      color: black;
      background: white !important;
      vertical-align: middle;

      i {
        font-size: 0.9rem;
        margin-top: -3px;
        margin-right: 0;
        vertical-align: middle;
      }
    }

    #ratings-reviews {
      .rating {
        border: none;
        float: left;
      }

      .rating div > input { display: none; }
      .rating div > label:before {
        margin: 5px;
        font-size: 1.25em;
        font-family: FontAwesome;
        display: inline-block;
        content: "\f005";
      }

      .rating div > .half:before {
        content: "\f089";
        position: absolute;
      }

      .rating div > label {
        color: #ddd;
        float: right;
      }

      /***** CSS Magic to Highlight Stars on Hover *****/

      .rating div > input:checked ~ label, /* show gold star when clicked */
      .rating:not(:checked) div > label:hover, /* hover current star */
      .rating:not(:checked) div > label:hover ~ label { color: $primary;  } /* hover previous stars in list */

      .rating div > input:checked + label:hover, /* hover current star when changing rating */
      .rating div > input:checked ~ label:hover,
      .rating div > label:hover ~ input:checked ~ label, /* lighten current selection */
      .rating div > input:checked ~ label:hover ~ label { color: $primary;  }
    }

    #photosModal {
      .image {
        position: relative;

        img.large {
          width: 100%;
          height: auto;
        }

        .btn-prev {
          position: absolute;
          left: 0rem;
          top: 50%;
          transform: translateY(-50%);
          padding: 0.5rem;
          opacity: 0.8;

          i {
            margin-right: 0;
          }
        }
        .btn-next {
          position: absolute;
          right: 0rem;
          top: 50%;
          transform: translateY(-50%);
          padding: 0.5rem;
          opacity: 0.8;

          i {
            margin-right: 0;
          }
        }
      }

      .modal-footer {
        background-color: #f0f0f0;
      }
    }

    .btn-instagram {
      color: white;
    }

    .social-activities {
      #photos {
        img {
          width: 100%;
          height: auto;
        }
      }

      #posts {
        .btn-facebook {
          color: #3c5a99;

          img {
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>

  #sticky-header {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    color: white;
    background: #222;
    z-index: 9;

    .user-name {
      position: relative;

      &.verified {
        margin-right: 1rem;
      }

      .verified-badge {
        position: absolute;
        right: -1.6rem;
        top: 0rem;
        z-index: 3;

        span.material-icons {
          color: #6ecdff;
          border-radius: 50%;
          font-size: 1.4rem;
          /*background: white;*/
          border-radius: 50%;
        }
      }

      .premium-badge {
        position: absolute;
        right: -1.6rem;
        top: -0.1rem;
        z-index: 3;

        img {
          width: 20px;
          height: auto;
        }
      }

      .free-member {
        display: inline;
        font-size: 0.7rem;
        font-style: italic;
      }
    }

    &.sticky {
      display: block;
    }

    .specialities {
      font-size: 0.8rem;
      span {
        padding: 0;

        &:after {
          content: '-';
        }

        &:last-child {
          &:after {
            content: '';
          }
        }
      }
    }

    .own-profile {
      font-size: 0.8rem;
      font-style: italic;
    }

    .btn-secondary {
      color: #222 !important;
      border-color: white !important;
      background-color: white !important;

      .material-icons {
        color: #222;

        @include media-breakpoint-down(sm) {
          margin: 0;
          color: white;
        }
      }

      span {
        @include media-breakpoint-down(sm) {
          display: none;
        }
      }

      @include media-breakpoint-down(sm) {
        border-color: transparent !important;
        background-color: transparent !important;
      }
    }
  }

  .btn-offline {
    color: #222 !important;
    border-color: #222 !important;
    background-color: white !important;
  }
  .btn-online {
    color: white !important;
    border-color: #6ecdff !important;
    background-color: #6ecdff !important;

    .material-icons {
      margin-top: -0.3rem;
      vertical-align: middle;
    }
  }

  .online-services {
    position: relative;
    background: linear-gradient(90deg, #f5f5f5 50%, #ececec 50%);

    .online-services-header {
      position: relative;
      display: flex;
      align-items: center;
      align-content: center;
      min-height: 300px;
      color: white;
      background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_online.jpg) no-repeat center center;
      background-size: cover;
      overflow: visible;

      h2 {
        margin-top: 0 !important;
      }

      .btn {
        color: #222;
        border-color: white !important;
        background-color: white !important;

        .material-icons {
          margin-top: -0.2rem;
        }
      }
    }

    h2 {
      .material-icons {
        color: #6ecdff !important;
        padding-right: 0.5rem;
      }
    }

    .websites-title {
      color: #333;
      border-bottom: 1px solid #ccc;
    }

    .website-item {
      display:flex;
      align-items:flex-start;
      align-content:flex-start;
      flex-direction: row;
      margin-bottom: 1rem;

      a.btn.website {
        color: white !important;
        background-color: #6ecdff;
        height: auto;
      }

      .website-description {
        margin-left: 1rem;

        @include media-breakpoint-down(md) {
          margin-left: 0;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      @include media-breakpoint-down(md) {
        flex-direction: column;
      }
    }

    .training-method {
      color: #526c8d;
      padding: 0.5rem;
      border: 1px solid #526c8d !important;
      background-color: transparent !important;
      width: auto !important;
      text-align: center;

      .material-icons {
        font-size: 2rem;
      }

      @include media-breakpoint-down(sm) {
        display: block;
        margin: 0 auto;
        width: 50% !important;
      }
    }

    @include media-breakpoint-down(sm) {
      background: #f5f5f5;
    }
  }
</style>
